import React from 'react';
var InlineDisplay = function (props) { return (React.createElement("div", { style: {
        display: 'inline-block',
        textAlign: 'center',
        margin: '1rem 0.25rem',
    } },
    props.component,
    React.createElement("br", null),
    React.createElement("span", { style: { display: 'block' } },
        props.label,
        React.createElement("br", null),
        props.info ? "(" + props.info + ")" : React.createElement("br", null)))); };
export default InlineDisplay;



//////////////////
// WEBPACK FOOTER
// ./src/pages/PageKitchen/InlineDisplay.tsx
// module id = 1325
// module chunks = 0